// event-invitations.js

const initialState = {}

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        default:
            return state
    }
}

// Thunks
/**
 * Update API invitation
 *
 * @param {string} slug - event slug
 * @param {Object} invitation
 * @param {boolean} active
 * @param {string} allowedRosterPositions
 * @param {integer} stateId
 * @return {Promise}
 */
export const updateInvitation = (
    slug,
    invitation,
    active,
    allowedRosterPositions = null,
    stateId = null
// eslint-disable-next-line max-params
) => (
    window.axios
        .patch(`${window.APP_CONFIG.REACT_APP_API_URL}api/events/${slug}/invitations?include=description,group,user`, {
            ...invitation,
            active,
            allowed_roster_positions: allowedRosterPositions || invitation.allowedRosterPositions,
            state_id: stateId || invitation.state_id,
            simple_response: true,
        })
        .then(({ data }) =>  new Promise(resolve => resolve(data.data)))
)

/**
 * Trash invitation on API
 *
 * @param {string} slug - event slug
 * @param {Object} invitation
 * @return {Promise}
 */
export const deleteInvitation = (slug, invitation) => (
    window.axios
        .delete(
            `${window.APP_CONFIG.REACT_APP_API_URL}api/events/${slug}/invitations/${invitation.id}`
        )
)
